import { globalStyle, style, styleVariants } from "@vanilla-extract/css";
import { vars } from "plos/src/styles";

export const fdrTableCell = style({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  padding: vars.space["2xs"],
});

export const doubleEventGroup = style({
  display: "flex",
  flexDirection: "column",
  gap: 1,
});

// In a double gameweek the fixtures are joined, so round only the outer edges.
globalStyle(`${doubleEventGroup} > div:first-child`, {
  borderBottomLeftRadius: 0,
  borderBottomRightRadius: 0,
});

globalStyle(`${doubleEventGroup} > div:not(:first-child):not(:last-child)`, {
  borderRadius: 0,
});

globalStyle(`${doubleEventGroup} > div:last-child`, {
  borderTopLeftRadius: 0,
  borderTopRightRadius: 0,
});

const difficultyCellBase = style({
  display: "flex",
  justifyContent: "center",
  borderRadius: vars.radii.xs,
  padding: `2px ${vars.space["xs"]}`,
  width: 55,
  fontFamily: vars.fonts.bold,
  fontSize: vars.fontSizes.body.s,
});

export const difficultyCell = styleVariants({
  1: [difficultyCellBase, vars.colors.difficulties[1]],
  2: [difficultyCellBase, vars.colors.difficulties[2]],
  3: [difficultyCellBase, vars.colors.difficulties[3]],
  4: [difficultyCellBase, vars.colors.difficulties[4]],
  5: [difficultyCellBase, vars.colors.difficulties[5]],
  0: [
    difficultyCellBase,
    {
      color: vars.colors.primaryFixed,
      backgroundColor: vars.colors.surfaceFixed,
    },
  ],
});
